var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9 13.108-5.29 3.173 1.383-6.011L.44 6.219l6.145-.543L9 0l2.415 5.676 6.145.543-4.653 4.05 1.383 6.012z","fill":"currentColor","fillRule":"evenodd"}));
}

StarInline.defaultProps = {"width":"18","height":"17","viewBox":"0 0 18 17"};

module.exports = StarInline;

StarInline.default = StarInline;
